import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';
import { contactInfo } from '../mockData';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: '#1a1c1b',
      borderTop: '1px solid rgba(63, 72, 22, 0.5)',
      padding: '60px 40px 30px'
    }}>
      <div style={{
        maxWidth: '87.5rem',
        margin: '0 auto'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '40px',
          marginBottom: '40px'
        }}>
          {/* Company Info */}
          <div>
            <h3 style={{
              fontFamily: 'Arial, sans-serif',
              fontWeight: 900,
              fontSize: '1.5rem',
              color: '#d9fb06',
              textTransform: 'uppercase',
              marginBottom: '16px'
            }}>
              Worklink Global
            </h3>
            <p style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontSize: '1rem',
              color: '#888680',
              lineHeight: 1.6,
              marginBottom: '12px'
            }}>
              Australia's trusted workforce aggregator delivering skilled labour and complete workforce solutions.
            </p>
            <p style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontSize: '0.9rem',
              color: '#888680',
              lineHeight: 1.4,
              marginBottom: '20px',
              fontStyle: 'italic'
            }}>
              Workforce and supply coordination, simplified.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontWeight: 600,
              fontSize: '1rem',
              color: '#d9fb06',
              textTransform: 'uppercase',
              marginBottom: '16px',
              letterSpacing: '0.05em'
            }}>
              Quick Links
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                { path: '/about', label: 'About Us' },
                { path: '/services', label: 'Services' },
                { path: '/industries', label: 'Industries' },
                { path: '/compliance', label: 'Compliance' }
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  style={{
                    color: '#888680',
                    textDecoration: 'none',
                    fontFamily: 'Inter, Arial, sans-serif',
                    fontSize: '0.95rem',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#d9fb06'}
                  onMouseLeave={(e) => e.target.style.color = '#888680'}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* For Partners */}
          <div>
            <h4 style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontWeight: 600,
              fontSize: '1rem',
              color: '#d9fb06',
              textTransform: 'uppercase',
              marginBottom: '16px',
              letterSpacing: '0.05em'
            }}>
              Partners
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                { path: '/for-clients', label: 'For Clients' },
                { path: '/for-suppliers', label: 'For Suppliers' },
                { path: '/contact', label: 'Contact Us' }
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  style={{
                    color: '#888680',
                    textDecoration: 'none',
                    fontFamily: 'Inter, Arial, sans-serif',
                    fontSize: '0.95rem',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#d9fb06'}
                  onMouseLeave={(e) => e.target.style.color = '#888680'}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontWeight: 600,
              fontSize: '1rem',
              color: '#d9fb06',
              textTransform: 'uppercase',
              marginBottom: '16px',
              letterSpacing: '0.05em'
            }}>
              Contact
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <MapPin size={16} style={{ color: '#d9fb06' }} />
                <span style={{ color: '#888680', fontSize: '0.95rem', fontFamily: 'Inter, Arial, sans-serif' }}>
                  {contactInfo.location}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Mail size={16} style={{ color: '#d9fb06' }} />
                <a
                  href={`mailto:${contactInfo.email}`}
                  style={{
                    color: '#888680',
                    textDecoration: 'none',
                    fontSize: '0.95rem',
                    fontFamily: 'Inter, Arial, sans-serif',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#d9fb06'}
                  onMouseLeave={(e) => e.target.style.color = '#888680'}
                >
                  {contactInfo.email}
                </a>
              </div>
              {contactInfo.phone && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Phone size={16} style={{ color: '#d9fb06' }} />
                  <span style={{ color: '#888680', fontSize: '0.95rem', fontFamily: 'Inter, Arial, sans-serif' }}>
                    {contactInfo.phone}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(63, 72, 22, 0.5)',
          paddingTop: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p style={{
            color: '#888680',
            fontSize: '0.875rem',
            fontFamily: 'Inter, Arial, sans-serif',
            margin: 0
          }}>
            © {new Date().getFullYear()} Worklink Global. All rights reserved.
          </p>
          <p style={{
            color: '#888680',
            fontSize: '0.875rem',
            fontFamily: 'Inter, Arial, sans-serif',
            margin: 0
          }}>
            {contactInfo.expansion}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
